/* eslint-disable react/require-default-props */

import React from 'react';
import ReactSlider from 'react-slider';
import Tooltip from 'components/Typography/Tooltip';
import './index.scss';

export default function Slider({
  min,
  max,
  value,
  setValue,
  step = 1,
  renderOnThumb = () => '',
  id = undefined,
  className = '',
}: {
  min: number;
  max: number;
  value: number;
  setValue: (value: number) => void;
  step?: number;
  renderOnThumb?: (
    (state: { valueNow: number, index: number, value: number }) => string
  ) | undefined;
  id?: string | undefined;
  className?: string;
}) {
  return (
    <div id={id} className={`ds-slider ${className}`}>
      <ReactSlider
        min={min}
        max={max}
        value={value}
        step={step}
        onChange={setValue}
        thumbClassName="thumb"
        trackClassName="track"
        renderThumb={(props, state) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars, react/prop-types
          const { key, ...restProps } = props as any;
          return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <div {...restProps}>
              {renderOnThumb && (
                <div className="render-on-thumb">
                  <Tooltip>
                    {renderOnThumb(state)}
                  </Tooltip>
                </div>
              )}
            </div>
          );
        }}
        renderTrack={(props, state) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars, react/prop-types
          const { key, ...restProps } = props as any;
          return (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <div {...restProps}>
              <div className={state.index === 1 ? 'track-unfilled' : ''} />
            </div>
          );
        }}
      />
    </div>
  );
}
